import InvoiceService from 'common/InvoiceService';
import WebHttpService from './WebHttpService';
import config from './../clientConfig';

export default new InvoiceService(WebHttpService,config);